import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import CusInput from "../../../mui/custom_input/CusInput";
import CusForm from "../../../mui/CusForm";
import IconWarning from "../../../mui/JSXIcons/IconWarning";
import ShowContainer from "../../../mui/ShowContainer";
import CheckInfo from "../../../mui/site/check_info/CheckInfo";
import IconCardTopUp from "../../../mui/JSXIcons/IconCardTopUp";
import SuccessCancelButtons from "../../../mui/success_cancel_buttons/SuccessCancelButtons";
import { ENUM_CURRENCY } from "../../../../store/enums";
import Commission from "./commission/Commission";

export default function TopUpReal({
  currency,
  closeModal,
  min,
  max,
  setStep,
  setData,
  taxPercent,
  maxInvoices,
  defaultDeposit
}) {
  const { t } = useTranslation();
  const [btnLoading, setBtnLoading] = useState(false);
  const [valueTopUp, setValueTopUp] = useState(defaultDeposit);

  const infoByCurrency = {
    [ENUM_CURRENCY.RUB]: t("A deposit in rubles can be made by transfer through Russian banks."),
    [ENUM_CURRENCY.UZS]: t("A deposit in sums can be made by transfer through Uzbek banks")
  };

  const info = infoByCurrency[currency];

  const onSubmit = async (e, field) => {
    e.preventDefault();
    setBtnLoading(true);

    const data = { amount: +field.amount, currency };
    setStep(2);
    setData(data);
    setBtnLoading(false);
  };

  useEffect(() => {
    if (defaultDeposit) {
      setValueTopUp(defaultDeposit);
      return;
    }
  }, [min, currency, defaultDeposit]);

  return (
    <div className="top-up top-up__real">
      <p>{t("We do not require you to enter your card")}</p>
      <ShowContainer condition={!!info}>
        <CheckInfo className={"top-up__real__info"}>
          <p>{info}</p>
        </CheckInfo>
      </ShowContainer>
      <CusForm className={"top-up__real__form"} onSubmit={onSubmit}>
        <CusInput
          iconJSXstart={<IconCardTopUp />}
          placeholder={"Enter amount"}
          value={valueTopUp}
          required
          type={"number"}
          dataType={"number"}
          name={"amount"}
          autocomplete="transaction-amount"
          inputMode="decimal"
          min={min}
          max={max ? max : undefined}
          clearBtn
          onChange={(e) => setValueTopUp(e.target.value)}
        />

        <ShowContainer condition={min}>
          <div className="top-up__min-deposit">
            <IconWarning />
            <span className="top-up__min-deposit__text">
              {t("Minimum deposit")}
              <span className="top-up__min-deposit__value">
                {min}
                <span className="top-up__min-deposit__currency">{currency}</span>
              </span>
            </span>
          </div>
        </ShowContainer>

        <ShowContainer condition={taxPercent}>
          <Commission taxPercent={taxPercent} min={min} />
        </ShowContainer>

        <h3>{t("After receiving payment details, you must make a transfer to them.")}</h3>

        <ShowContainer condition={maxInvoices}>
          <p>
            {t(
              "Don't just create requests. You can create up to unpaid requests. After which, your ability to top up your balance will be suspended.",
              { count: maxInvoices }
            )}
          </p>
        </ShowContainer>

        <SuccessCancelButtons
          className="top-up__buttons"
          btnLoading={btnLoading}
          setBtnLoading={setBtnLoading}
          successText="Top up"
          closeModal={closeModal}
        />
      </CusForm>
    </div>
  );
}
